<template>
  <div class="app">

    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full containt-logo-custom-full" :src="logo" fluid :alt="proyectName" />
        <img class="navbar-brand-minimized containt-logo-custom-minimized" :src="favicon" fluid :alt="proyectName" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />

      <b-navbar-nav v-if="seeControls" class="header-controls-nav">
        <b-button v-if="arr.seccionOptions.length" 
                  @click="changeProfile()" 
                  type="button" 
                  variant="outline-dark" 
                  size="sm" 
                  class="btn-pill float-left ml-2 custom-container-change-profile" 
                  v-b-tooltip.hover title="Cambiar Perfil"
                  id="popover-container-change-profile">
          <i class="fa fa-exchange"></i>
        </b-button>
        <div v-else class="d-none d-lg-block">
          <div class="container-login-como">
            <b-badge variant="success">{{loginComo.profile}}</b-badge>
            {{this.loginComo.name}}<br>
            <small v-for="(value, index) in loginComo.subProfile" v-bind:key="index">          
              <div class="badge badge-pill badge-dark mr-1">{{value}}</div>
            </small>          
          </div>                  
        </div>

        <b-popover triggers="hover focus"                   
                  target="popover-container-change-profile">                            
          
          <div class="container-login-como">
            <b-badge variant="success">{{loginComo.profile}}</b-badge>
            {{this.loginComo.name}}<br>
            <small v-for="(value, index) in loginComo.subProfile" v-bind:key="index" class="small-container-change-profile">          
              <div class="badge badge-pill badge-dark mr-1">{{value}}</div>
            </small>          
          </div>        
        </b-popover>        

        <b-dropdown right
                    size="sm"
                    variant="outline-dark"
                    class="ml-2 shortcuts-dropdown d-none d-lg-inline-flex"
                    v-b-tooltip.hover.lefttop
                    title="Accesos directos"
                    v-if="shortcutItems.length">
          <template #button-content>
            <i class="fa fa-bookmark mr-1"></i>
            Accesos directos
          </template>
          <b-dropdown-form class="shortcut-lock-bar" @click.stop.prevent="toggleShortcutEditMode()">
            <b-icon :icon="shortcutEditMode ? 'unlock-fill' : 'lock-fill'" class="shortcut-lock-icon"></b-icon>
            <span>{{ shortcutEditMode ? 'Edición desbloqueada' : 'Edición bloqueada' }}</span>
          </b-dropdown-form>
          <b-dropdown-form v-if="shortcutEditMode" class="shortcut-add-divider" @click.stop.prevent="addShortcutDivider()">
            <b-icon icon="plus-circle" class="mr-1"></b-icon>
            <span>Agregar separador</span>
          </b-dropdown-form>
          <b-dropdown-item-button v-if="!shortcutItems.length" disabled>
            No hay accesos directos
          </b-dropdown-item-button>
          <template v-for="(item, index) in shortcutItems">
            <b-dropdown-form v-if="item.type === 'divider'"
                             :key="'d_' + index"
                             class="shortcut-divider"
                             :class="{ 'shortcut-divider-edit': shortcutEditMode }">
              <div class="shortcut-divider-main">
                <span v-if="!shortcutEditMode || editingShortcutIndex !== index" class="shortcut-divider-title">{{ item.title }}</span>
                <b-form-input v-else
                              size="sm"
                              v-model="editingShortcutTitle"
                              class="shortcut-input"
                              @click.stop
                              @keydown.enter.prevent.stop="saveShortcutTitleByIndex(index)"
                              @keydown.esc.prevent.stop="cancelShortcutEdit()"></b-form-input>
              </div>
              <div class="shortcut-actions" v-if="shortcutEditMode">
                <b-icon icon="arrow-up" class="shortcut-action" title="Subir" @click.stop="moveShortcutByIndex(index, 'up')"></b-icon>
                <b-icon icon="arrow-down" class="shortcut-action" title="Bajar" @click.stop="moveShortcutByIndex(index, 'down')"></b-icon>
                <b-icon v-if="editingShortcutIndex !== index" icon="pencil-square" class="shortcut-action" title="Renombrar" @click.stop="startShortcutEditByIndex(index, item)"></b-icon>
                <b-icon v-else icon="check2-circle" class="shortcut-action shortcut-action-save" title="Guardar" @click.stop="saveShortcutTitleByIndex(index)"></b-icon>
                <b-icon v-if="editingShortcutIndex === index" icon="x-circle" class="shortcut-action" title="Cancelar" @click.stop="cancelShortcutEdit()"></b-icon>
                <b-icon v-else icon="x-circle" class="shortcut-remove" title="Quitar separador" @click.stop="removeShortcutByIndex(index)"></b-icon>
              </div>
            </b-dropdown-form>
            <b-dropdown-item v-else
                             :key="(item.fullPath || '') + '_' + index"
                             @click="onShortcutItemClick(item)"
                             class="shortcut-item"
                             :class="{ 'shortcut-item-compact': !shortcutEditMode }">
              <div class="shortcut-main">
                <i class="shortcut-item-icon" :class="getShortcutIcon(item)"></i>
                <span v-if="!shortcutEditMode || editingShortcutIndex !== index" class="shortcut-title">{{ item.title }}</span>
                <b-form-input v-else
                              size="sm"
                              v-model="editingShortcutTitle"
                              class="shortcut-input"
                              @click.stop
                              @keydown.enter.prevent.stop="saveShortcutTitleByIndex(index)"
                              @keydown.esc.prevent.stop="cancelShortcutEdit()"></b-form-input>
              </div>
              <div class="shortcut-actions" v-if="shortcutEditMode">
                <b-icon icon="arrow-up" class="shortcut-action" title="Subir" @click.stop="moveShortcutByIndex(index, 'up')"></b-icon>
                <b-icon icon="arrow-down" class="shortcut-action" title="Bajar" @click.stop="moveShortcutByIndex(index, 'down')"></b-icon>
                <b-icon v-if="editingShortcutIndex !== index" icon="pencil-square" class="shortcut-action" title="Renombrar" @click.stop="startShortcutEditByIndex(index, item)"></b-icon>
                <b-icon v-else icon="check2-circle" class="shortcut-action shortcut-action-save" title="Guardar" @click.stop="saveShortcutTitleByIndex(index)"></b-icon>
                <b-icon v-if="editingShortcutIndex === index" icon="x-circle" class="shortcut-action" title="Cancelar" @click.stop="cancelShortcutEdit()"></b-icon>
                <b-icon v-else icon="x-circle" class="shortcut-remove" title="Quitar" @click.stop="removeShortcutByIndex(index)"></b-icon>
              </div>
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">   
        <div v-if="isSeller" :class="locationBadgeClass">
          <b-badge :variant="locationPermissionVariant"
                   class="mr-2 location-permission-badge"
                   v-b-tooltip.hover
                   :title="locationPermissionTooltip">
            GPS: {{locationPermissionLabel}}
          </b-badge>
          <b-badge :variant="locationLastSentVariant"
                   class="mr-2 location-last-sent-badge"
                   v-b-tooltip.hover
                   :title="locationLastSentTooltip">
            {{locationLastSentLabel}}
          </b-badge>
        </div>
        <DefaultHeaderDropdownAccnt :loginComo="loginComo"/>
        <b-button v-b-toggle.sidebar-aside
                v-if="seeAsside" 
                class="d-none d-lg-block siderbar-right asside-right-bar-custom" 
                v-b-tooltip.hover.lefttop 
                title="Despligue para mas funcionalidades">   
            <b-icon icon="collection-fill"></b-icon>
        </b-button>       
      </b-navbar-nav>
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">        
        <b-dropdown right
                    size="sm"
                    variant="outline-dark"
                    class="shortcuts-dropdown shortcuts-dropdown-full d-lg-none"
                    v-b-tooltip.hover
                    title="Accesos directos"
                    v-if="shortcutItems.length">
          <template #button-content>
            <i class="fa fa-bookmark mr-1"></i>
            Accesos directos
          </template>
          <b-dropdown-form class="shortcut-lock-bar" @click.stop.prevent="toggleShortcutEditMode()">
            <b-icon :icon="shortcutEditMode ? 'unlock-fill' : 'lock-fill'" class="shortcut-lock-icon"></b-icon>
            <span>{{ shortcutEditMode ? 'Edición desbloqueada' : 'Edición bloqueada' }}</span>
          </b-dropdown-form>
          <b-dropdown-form v-if="shortcutEditMode" class="shortcut-add-divider" @click.stop.prevent="addShortcutDivider()">
            <b-icon icon="plus-circle" class="mr-1"></b-icon>
            <span>Agregar separador</span>
          </b-dropdown-form>
          <b-dropdown-item-button v-if="!shortcutItems.length" disabled>
            No hay accesos directos
          </b-dropdown-item-button>
          <template v-for="(item, index) in shortcutItems">
            <b-dropdown-form v-if="item.type === 'divider'"
                             :key="'d_' + index"
                             class="shortcut-divider"
                             :class="{ 'shortcut-divider-edit': shortcutEditMode }">
              <div class="shortcut-divider-main">
                <span v-if="!shortcutEditMode || editingShortcutIndex !== index" class="shortcut-divider-title">{{ item.title }}</span>
                <b-form-input v-else
                              size="sm"
                              v-model="editingShortcutTitle"
                              class="shortcut-input"
                              @click.stop
                              @keydown.enter.prevent.stop="saveShortcutTitleByIndex(index)"
                              @keydown.esc.prevent.stop="cancelShortcutEdit()"></b-form-input>
              </div>
              <div class="shortcut-actions" v-if="shortcutEditMode">
                <b-icon icon="arrow-up" class="shortcut-action" title="Subir" @click.stop="moveShortcutByIndex(index, 'up')"></b-icon>
                <b-icon icon="arrow-down" class="shortcut-action" title="Bajar" @click.stop="moveShortcutByIndex(index, 'down')"></b-icon>
                <b-icon v-if="editingShortcutIndex !== index" icon="pencil-square" class="shortcut-action" title="Renombrar" @click.stop="startShortcutEditByIndex(index, item)"></b-icon>
                <b-icon v-else icon="check2-circle" class="shortcut-action shortcut-action-save" title="Guardar" @click.stop="saveShortcutTitleByIndex(index)"></b-icon>
                <b-icon v-if="editingShortcutIndex === index" icon="x-circle" class="shortcut-action" title="Cancelar" @click.stop="cancelShortcutEdit()"></b-icon>
                <b-icon v-else icon="x-circle" class="shortcut-remove" title="Quitar separador" @click.stop="removeShortcutByIndex(index)"></b-icon>
              </div>
            </b-dropdown-form>
            <b-dropdown-item v-else
                             :key="(item.fullPath || '') + '_' + index"
                             @click="onShortcutItemClick(item)"
                             class="shortcut-item"
                             :class="{ 'shortcut-item-compact': !shortcutEditMode }">
              <div class="shortcut-main">
                <i class="shortcut-item-icon" :class="getShortcutIcon(item)"></i>
                <span v-if="!shortcutEditMode || editingShortcutIndex !== index" class="shortcut-title">{{ item.title }}</span>
                <b-form-input v-else
                              size="sm"
                              v-model="editingShortcutTitle"
                              class="shortcut-input"
                              @click.stop
                              @keydown.enter.prevent.stop="saveShortcutTitleByIndex(index)"
                              @keydown.esc.prevent.stop="cancelShortcutEdit()"></b-form-input>
              </div>
              <div class="shortcut-actions" v-if="shortcutEditMode">
                <b-icon icon="arrow-up" class="shortcut-action" title="Subir" @click.stop="moveShortcutByIndex(index, 'up')"></b-icon>
                <b-icon icon="arrow-down" class="shortcut-action" title="Bajar" @click.stop="moveShortcutByIndex(index, 'down')"></b-icon>
                <b-icon v-if="editingShortcutIndex !== index" icon="pencil-square" class="shortcut-action" title="Renombrar" @click.stop="startShortcutEditByIndex(index, item)"></b-icon>
                <b-icon v-else icon="check2-circle" class="shortcut-action shortcut-action-save" title="Guardar" @click.stop="saveShortcutTitleByIndex(index)"></b-icon>
                <b-icon v-if="editingShortcutIndex === index" icon="x-circle" class="shortcut-action" title="Cancelar" @click.stop="cancelShortcutEdit()"></b-icon>
                <b-icon v-else icon="x-circle" class="shortcut-remove" title="Quitar" @click.stop="removeShortcutByIndex(index)"></b-icon>
              </div>
            </b-dropdown-item>
          </template>
        </b-dropdown>

        <b-alert show variant="warning" class="alert-clear-cache" v-if="alert.cache.show">
          Ante cualquier problema, limpie la memoria cache. 
          <a href="javascript:void(0);" class="alert-link" @click="clearCache()">Limpiar Cache</a>
          <a href="javascript:void(0);" class="alert-link pull-right hide-clear-cache" title="Ocultar aviso" @click="hideClearCache()">
            <b-icon icon="toggle-on"></b-icon>
          </a>
        </b-alert>        

        <div class="container-fluid">
          <!--<router-view :key="$route.path"></router-view>-->
          <tabs-layout />
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside v-if="seeAsside"/>
      </AppAside>
    </div>

    <TheFooter class="mt-3">
      <!--footer-->
      <div class="d-flex w-100 justify-content-between align-items-center">
        <div>
          <span class="mr-1">&copy; {{moment().format('YYYY')}} - Desarrollado por</span>
          <a :href="developer.url" target="_blank">{{this.developer.name}}</a>
        </div>
        <div v-if="isStaff">
          <a href="#" @click.prevent="goToChangelog()" class="text-muted" style="font-size: 12px;">
            <i class="fa fa-history mr-1"></i>Registro de Cambios
          </a>
        </div>
      </div>
    </TheFooter>

    <b-modal v-model="modal.changePerfil.active"
             headerBgVariant="dark"
             bodyBgVariant="light"
             title="Cambiar Perfil"
             no-close-on-esc
             no-close-on-backdrop
             hide-header-close
             centered>

      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item v-for="(item, index) in arr.seccionOptions"
                               :key="index"
                               @click="reloadProfile(item)"
                               href="#"
                               class="flex-column align-items-start container-list-group-item-custom"
                               v-b-tooltip.hover title="Click para cambiar la sessión del usuario">

              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.selectorSeccionName}}</h5>
                <b-badge variant="secondary" class="badge-selector-profile-custom" pill>{{ item.profileName }}</b-badge>
              </div>

            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button type="button" variant="outline-secondary" @click="cancelProfile()">Cancelar</b-button>
      </template>

    </b-modal>
  </div>
</template>

<script>
import Session from '@/handler/session'
import Profiles from '@/config/profiles'
import Helper from '@/handler/helper'
import MenuSuperadmin from '@/components/containers/menuSuperadmin'
import MenuAdmin from '@/components/containers/menuAdmin'
import Menu from '@/components/containers/menu'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DefaultAside from './DefaultAside'
import {EventBus} from '@/handler/event-bus'
import serviceAPI from './services'
import Error from '@/handler/error'
import Storage from '@/handler/storageLocal'
import TabsLayout from '@/components/containers/DefaultTabsLayout.vue'
import LocationTracker from '@/handler/locationTracker'
import shortcuts from '@/handler/shortcuts'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    DefaultAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    TabsLayout,
  },
  data () {
    return {
      proyectName: '',
      logo: '',
      favicon: '',
      colorTitleMenu: '',
      colorSelectMenu: '',
      primaryColor: '',
      nav: [],
      seeControls: false,
      seeAsside: false,
      modal: {
        changePerfil: {
          active: false,
        }
      },
      arr: {
        seccionOptions : []
      },
      loginComo: {
        profile: '',
        subProfile: [],
        name: '',
      },
      developer: {
        name: '',
        url: ''
      },
      alert:{
        cache: {
          show: false
        }
      },
      shortcutItems: [],
      shortcutEditMode: false,
      editingShortcutPath: '',
      editingShortcutIndex: -1,
      editingShortcutTitle: '',
      locationPermission: 'unknown',
      locationLastSentAt: 0,
      locationLastSentTick: 0,
      locationLastSentTimer: null
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    isSeller(){
      if(Helper.getSeller()) {
        return true
      } else {
        return false
      }
    },
    isEmployee(){
      if(Helper.getEmployee() && !Helper.getEmployee().permission_admin_projects) {
        return true
      } else {
        return false
      }
    },
    isStaff() {
      if (Session.getSession().auth) {
        return parseInt(Session.getSession().auth.user.profile_id) === Profiles.PERSONAL
      }
      return false
    },
    locationPermissionLabel() {
      switch (this.locationPermission) {
        case 'granted':
          return 'Permitido'
        case 'denied':
          return 'Denegado'
        case 'prompt':
          return 'Pendiente'
        case 'unsupported':
          return 'No Soportado'
        default:
          return 'Desconocido'
      }
    },
    locationPermissionVariant() {
      switch (this.locationPermission) {
        case 'granted':
          return 'success'
        case 'denied':
          return 'danger'
        case 'prompt':
          return 'warning'
        case 'unsupported':
          return 'secondary'
        default:
          return 'dark'
      }
    },
    locationPermissionTooltip() {
      switch (this.locationPermission) {
        case 'granted':
          return 'Permiso de ubicación concedido'
        case 'denied':
          return 'Permiso de ubicación denegado'
        case 'prompt':
          return 'Permiso de ubicación pendiente'
        case 'unsupported':
          return 'El navegador no soporta geolocalización'
        default:
          return 'Estado de permisos desconocido'
      }
    },
    locationLastSentLabel() {
      if (!this.locationLastSentAt) {
        return 'Ultimo: sin envios'
      }

      const now = this.locationLastSentTick || Date.now()
      const diffMs = Math.max(0, now - this.locationLastSentAt)
      const diffMin = Math.floor(diffMs / 60000)

      if (diffMin <= 0) {
        return 'Ultimo: recien'
      }
      if (diffMin < 60) {
        return `Ultimo: hace ${diffMin}m`
      }

      const hours = Math.floor(diffMin / 60)
      const minutes = diffMin % 60
      if (hours < 24) {
        return `Ultimo: hace ${hours}h ${minutes}m`
      }

      const days = Math.floor(hours / 24)
      const remHours = hours % 24
      return `Ultimo: hace ${days}d ${remHours}h`
    },
    locationLastSentVariant() {
      return this.locationLastSentAt ? 'info' : 'secondary'
    },
    locationLastSentTooltip() {
      if (!this.locationLastSentAt) {
        return 'Aun no hay envios registrados'
      }

      if (typeof moment === 'function') {
        return 'Ultimo envio: ' + moment(this.locationLastSentAt).format('YYYY-MM-DD HH:mm')
      }

      const date = new Date(this.locationLastSentAt)
      return 'Ultimo envio: ' + date.toLocaleString()
    },
    locationBadgeClass() {
      return {
        'location-badges': true,
        'location-badges-stacked': true
      }
    },
  },
  created () {
    EventBus.$on('Settings:settings', data => {
      this.setup()
    })
    EventBus.$on('Shortcuts:updated', list => {
      this.shortcutItems = list || []
    })
  },
  mounted() {
    this.setup()
    this.statusClearCache()
    this.initLocationTracker()
    this.loadShortcuts()
  },    
  beforeDestroy() {
    if (this.locationLastSentTimer) {
      clearInterval(this.locationLastSentTimer)
      this.locationLastSentTimer = null
    }

    window.removeEventListener('seller-location-permission', this.onLocationPermission)
    window.removeEventListener('seller-location-last-sent', this.onLocationLastSent)
  },
  methods: {
    initLocationTracker() {
      if(this.isSeller) {
        LocationTracker.start()
        this.refreshLocationPermission()
        this.locationLastSentAt = LocationTracker.getLastSent ? LocationTracker.getLastSent() : 0
        this.locationLastSentTick = Date.now()
        this.startLocationLastSentTicker()
        window.addEventListener('seller-location-permission', this.onLocationPermission)
        window.addEventListener('seller-location-last-sent', this.onLocationLastSent)
      }
    },
    refreshLocationPermission() {
      LocationTracker.checkPermission().then((state) => {
        this.locationPermission = state || 'unknown'
      })
    },
    onLocationPermission(event) {
      if(event && event.detail && event.detail.state) {
        this.locationPermission = event.detail.state
      } else {
        this.locationPermission = 'unknown'
      }
    },
    onLocationLastSent(event) {
      if (event && event.detail && event.detail.timestamp) {
        this.locationLastSentAt = event.detail.timestamp
        this.locationLastSentTick = Date.now()
      }
    },
    startLocationLastSentTicker() {
      if (this.locationLastSentTimer) {
        clearInterval(this.locationLastSentTimer)
      }

      this.locationLastSentTimer = setInterval(() => {
        this.locationLastSentTick = Date.now()
      }, 60000)
    },
    loadShortcuts() {
      this.shortcutItems = shortcuts.all()
      shortcuts.syncFromServer().then(list => {
        if (list) {
          this.shortcutItems = list
        }
      })
    },
    goToShortcut(item) {
      if (item && item.fullPath) {
        this.$router.push(item.fullPath).catch(() => {})
      }
    },
    onShortcutItemClick(item) {
      if (this.shortcutEditMode) return
      this.goToShortcut(item)
    },
    toggleShortcutEditMode() {
      this.shortcutEditMode = !this.shortcutEditMode
      if (!this.shortcutEditMode) {
        this.cancelShortcutEdit()
      }
    },
    removeShortcut(item) {
      if (!item || !item.fullPath) return
      this.shortcutItems = shortcuts.remove(item.fullPath)
      if (this.editingShortcutPath === item.fullPath) {
        this.cancelShortcutEdit()
      }
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
    },
    startShortcutEdit(item) {
      if (!item || !item.fullPath) return
      this.editingShortcutPath = item.fullPath
      this.editingShortcutTitle = item.title || ''
    },
    cancelShortcutEdit() {
      this.editingShortcutPath = ''
      this.editingShortcutIndex = -1
      this.editingShortcutTitle = ''
    },
    saveShortcutTitle(item) {
      if (!item || !item.fullPath) return
      const value = (this.editingShortcutTitle || '').trim()
      if (!value) {
        this.$awn.warning('Ingrese un nombre para el acceso directo')
        return
      }
      this.shortcutItems = shortcuts.rename(item.fullPath, value)
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
      this.cancelShortcutEdit()
    },
    moveShortcut(item, direction) {
      if (!item || !item.fullPath) return
      this.shortcutItems = shortcuts.move(item.fullPath, direction)
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
    },
    addShortcutDivider() {
      this.shortcutItems = shortcuts.addDivider('Grupo')
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
    },
    startShortcutEditByIndex(index, item) {
      this.editingShortcutIndex = index
      this.editingShortcutPath = ''
      this.editingShortcutTitle = item.title || ''
    },
    saveShortcutTitleByIndex(index) {
      var value = (this.editingShortcutTitle || '').trim()
      if (!value) {
        this.$awn.warning('Ingrese un nombre')
        return
      }
      this.shortcutItems = shortcuts.renameByIndex(index, value)
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
      this.cancelShortcutEdit()
    },
    moveShortcutByIndex(index, direction) {
      this.shortcutItems = shortcuts.moveByIndex(index, direction)
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
    },
    removeShortcutByIndex(index) {
      if (this.editingShortcutIndex === index) {
        this.cancelShortcutEdit()
      }
      this.shortcutItems = shortcuts.removeByIndex(index)
      EventBus.$emit('Shortcuts:updated', this.shortcutItems)
    },
    getShortcutIcon(item) {
      if (!item || !item.fullPath) return 'fa fa-bookmark'
      const icon = this.findNavIconByPath(item.fullPath)
      return icon || 'fa fa-bookmark'
    },
    findNavIconByPath(path) {
      if (!path || !this.nav || !this.nav.length) return ''
      const clean = String(path).split('?')[0].split('#')[0].replace(/\/+$/, '')
      const helper = (nodes) => {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i]
          if (!node) continue
          if (node.url) {
            const nodeUrl = String(node.url).replace(/\/+$/, '')
            if (nodeUrl === clean || clean.startsWith(nodeUrl + '/')) {
              return node.icon || ''
            }
          }
          if (node.children && node.children.length) {
            const found = helper(node.children)
            if (found) return found
          }
        }
        return ''
      }
      return helper(this.nav)
    },
    setup () {      
      if(Session.getSession().settings) {
        this.proyectName = Session.getSession().settings.proyect_name
        this.logo = Session.getSession().settings.logo
        this.favicon = Session.getSession().settings.favicon
        this.colorTitleMenu = Session.getSession().settings.color_title_menu
        this.colorSelectMenu = Session.getSession().settings.color_select_menu
        this.primaryColor = Session.getSession().settings.color_primary

        this.createCSS()
        this.configMenu()
        this.configLoginComo()
        this.configSelectProfile()
        this.configDeveloper()
      }
    },
    createCSS() {
      var hoja = document.createElement('style')
      hoja.innerHTML = ""
      hoja.innerHTML = hoja.innerHTML  + ".nav-title { background: " + this.colorTitleMenu + "; }"
      hoja.innerHTML = hoja.innerHTML  + ".sidebar .nav-link:hover { background: " + this.colorSelectMenu + " !important; }"
      hoja.innerHTML = hoja.innerHTML  + ".siderbar-right { background: " + this.colorTitleMenu + " !important; padding: 11px !important; border-radius: 0px !important; color: #fff; font-size: 20px;}"
      hoja.innerHTML = hoja.innerHTML  + ".sidebar .nav-link.active .nav-icon { color: " + this.primaryColor + "}"
      hoja.innerHTML = hoja.innerHTML  + ".sidebar-minimized .sidebar .nav-item:hover > .nav-link  { background: " + this.colorSelectMenu + "}"
      hoja.innerHTML = hoja.innerHTML  + ".b-pagination .page-item.active .page-link { background-color: " + this.primaryColor + "; border-color: " + this.primaryColor + "; }"
      hoja.innerHTML = hoja.innerHTML  + "a {color: " + this.primaryColor + ";}"
      hoja.innerHTML = hoja.innerHTML  + "a:hover {color: " + this.primaryColor + "; filter: brightness(85%);}"
      hoja.innerHTML = hoja.innerHTML  + ".selected-custom {color: " + this.primaryColor + ";}"
      hoja.innerHTML = hoja.innerHTML  + ".selected-custom:hover {color: " + this.primaryColor + "; filter: brightness(85%);}"
      hoja.innerHTML = hoja.innerHTML  + ".btn-link {color: " + this.primaryColor + ";}"
      hoja.innerHTML = hoja.innerHTML  + ".btn-link:hover {color: " + this.primaryColor + "; filter: brightness(85%);}"
      hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus, .list-group-item-action.active {background-color: " + this.primaryColor + " !important; color: #fff !important; border-color: " + this.primaryColor + " !important;}"
      hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover .text-muted, .list-group-item-action:focus .text-muted, .list-group-item-action.active .text-muted {color: #ffffffcc !important;}"
      hoja.innerHTML = hoja.innerHTML  + ".asside-right-bar-custom {background: " + this.primaryColor + ";}"
      hoja.innerHTML = hoja.innerHTML  + ".aside-menu .nav-tabs .nav-link.active {color: " + this.primaryColor + ";}"
      hoja.innerHTML = hoja.innerHTML  + ".sidebar .nav-link.active {color: #fff !important;}"
      hoja.innerHTML = hoja.innerHTML  + ".nav-pills .nav-link.active, .nav-pills .show > .nav-link {background-color: " + this.primaryColor + " !important; color: #fff !important;}"
      hoja.innerHTML = hoja.innerHTML  + ".b-sidebar .list-group-item:hover, .b-sidebar .list-group-item.active, .b-sidebar .list-group-item:focus {background-color: " + this.primaryColor + " !important; color: #fff !important; border-color: " + this.primaryColor + " !important;}"
      
      document.body.appendChild(hoja);
    },
    configMenu() {
      if(Session.getSession().auth) {
        if(Session.getSession().auth.user.profile_id == Profiles.SUPERADMIN) {
          this.nav = MenuSuperadmin.getItems()
          this.seeControls = false
          this.seeAsside = false
        } else {
          if(Session.getSession().auth.user.profile_id == Profiles.PERSONAL &&
             Session.getSession().auth.user.rol_admin) {
            this.nav = MenuAdmin.getItems()
            this.seeControls = false
            this.seeAsside = false
          } else {
            this.nav = Menu.getItems(Session.getSession().auth.user.permissions.menu)
            this.seeControls = true

            if(this.isSeller || this.isEmployee) {
              this.seeAsside = false
            } else {
              this.seeAsside = true
            }
          }
        }
        
        if(Session.getSession().auth.user.profile_id == Profiles.CLIENTE) {
          this.seeAsside = false
        }
        if(Session.getSession().auth.user.profile_id == Profiles.PROVEEDOR) {
          this.seeAsside = false
        }
      }
    },
    configLoginComo() {
      if(Session.getSession().auth) {
        if(Session.getSession().auth.user.profile_default) {

          if(Session.getSession().auth.user.profile_default.id == Profiles.PERSONAL) {
            this.loginComo.profile = "Staff"

            if(Helper.getEmployee()) {              
              this.loginComo.subProfile.push(Helper.getEmployee().category.name)
            }
            
            if(Helper.getSeller()) {              
              if(!this.loginComo.subProfile.length) {
                this.loginComo.subProfile.push('Comercial') 
              }              
            }
          }
          if(Session.getSession().auth.user.profile_default.id == Profiles.CLIENTE) {
            this.loginComo.profile = "Cliente"
          }
          if(Session.getSession().auth.user.profile_default.id == Profiles.PROVEEDOR) {
            this.loginComo.profile = "Proveedor"
          }

          if (!Session.getSession().auth.user.selector_session){
            if(Session.getSession().auth.user.profile_id!=Profiles.SUPERADMIN) {
              if(Session.getSession().auth.user.rol_admin==false) {
                this.modal.changePerfil.active = true
              }
            }
          } else {
            this.loginComo.name = Session.getSession().auth.user.selector_session_name
          }
        }
      }
    },
    configSelectProfile() {
      var arrayProfiles = []
      if(Session.getSession().auth) {
        var permission = Session.getSession().auth.user.profile_access
        for (const prop in permission.staff) {
          arrayProfiles.push({
            profileId: Profiles.PERSONAL,
            profileName: 'Staff',
            selectorSeccion: permission.staff[prop].id,
            selectorSeccionName: permission.staff[prop].name
          })
        }
        for (const prop in permission.customers) {
          arrayProfiles.push({
            profileId: Profiles.CLIENTE,
            profileName: 'Cliente',
            selectorSeccion: permission.customers[prop].id,
            selectorSeccionName: permission.customers[prop].name
          })
        }
        for (const prop in permission.suppliers) {
          arrayProfiles.push({
            profileId: Profiles.PROVEEDOR,
            profileName: 'Proveedor',
            selectorSeccion: permission.suppliers[prop].id,
            selectorSeccionName: permission.suppliers[prop].name
          })
        }
        this.arr.seccionOptions = arrayProfiles
      }
    },
    changeProfile() {
      var hoja = document.createElement('style')
      hoja.innerHTML = ""
      hoja.innerHTML = hoja.innerHTML  + ".container-list-group-item-custom:hover { background: " + this.primaryColor + "; color: white;}"
      document.body.appendChild(hoja);
      this.modal.changePerfil.active = true
    },
    reloadProfile(item) {
      let loader = this.$loading.show();
      var result = serviceAPI.configSession(item);

      result.then((response) => {

        var result_1 = serviceAPI.getSessionUser();
        result_1.then((response_1) => {
          var data = response_1.data

          Session.setSessionAuth(data)
          this.$router.push({ name: 'Init' })
          this.modal.changePerfil.active = false

          loader.hide()
        })
        .catch(error_1 => {
          loader.hide()
          this.$awn.alert(Error.showError(error_1))
        })

      })
      .catch(error => {
        loader.hide()
        this.$awn.alert(Error.showError(error));
      })
    },
    cancelProfile(){
      if (!Session.getSession().auth.user.selector_session){
        this.modal.changePerfil.active = true
        this.$awn.alert("No se cargo el perfil por defecto")
      } else {
        this.modal.changePerfil.active = false
      }
    },
    goToChangelog() {
      this.$router.push({ name: 'ChangelogStaff' })
    },
    configDeveloper() {
      if(Session.getSession().auth) {
        if(Session.getSession().auth.developer) {
          this.developer.name = Session.getSession().auth.developer.name
          this.developer.url = Session.getSession().auth.developer.url
        }
      }
    },

    // CACHE
    clearCache() {
      this.$router.push({ name: 'Clear'}).catch(err => {
          
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if ( err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')) {
          
          // But print any other errors to the console
              logError(err);
          }
      });           
    },        
    statusClearCache() {              
      this.alert.cache.show = false
      Storage.setValue('show_alert_clear_cache', false)
    },      
    hideClearCache() {
      this.alert.cache.show = false
      Storage.setValue('show_alert_clear_cache', false)
    }
  }
}
</script>

<style>  
  body {
    background-color: #e4e5e6 !important;    
  }
  .sidebar-minimized .sidebar .nav > .nav-dropdown:hover {
    background: #2f353a;
  }
  .nav-dropdown-items {
    background: #00000033;
  }
  .main .container-fluid {
    padding: 0 15px;
    /*margin-top: 15px;*/
  }
  .siderbar-right:hover {
    background: #c8ced3 !important;
    color: #fff;
  }
  .card {
    margin-bottom: 10px;
  }
  .table th, .table td {
    padding: 5px;
  }
  .container-login-como {
    font-weight: bold;
  }
  .container-login-como span {
    font-size: 15px;
  }
  .vld-overlay.is-full-page {
    z-index: 99999 !important;
    background-color: #00000054 !important;
  }
  .btn-sm, .btn-group-sm > .btn {
    padding: 0.15rem 0.5rem;
  }
  .modal-header {
    font-weight: 500;
    font-size: 17px;
  }
  .material-icons {
    font-size: 18px;
  }
  .badge-selector-profile-custom {
    padding-top: 0.6em;
  }
  legend {
    font-weight: 600;
  }
  @media (min-width: 992px){
    .sidebar-minimized .sidebar section :not(.nav-dropdown-items) > .nav-item:last-child::after {
      display: none;
    }
  }
  .module-help-information {
    cursor: pointer;
  }
  
  .widget-custom .card-header{
    padding: 0px;
  }
  .widget-custom .card-body{
    padding: 5px;
  }
  .widget-header-custom {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .widget-info-custom {
    padding-top: 4px;
    padding-bottom: 2px;
    padding-left: 8px;
    padding-right: 8px;
    background: white;
    color: black;
    border-radius: 50%;
    cursor: pointer;
  }
  .widget-ultima-actualizacion {
    cursor: pointer;
  }
  .widget-ultima-actualizacion span {
    background: #efefef;
    padding-left: 5px;
    padding-right: 5px;
  }
  .card-footer {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .widget-router-custom {
    position: absolute;
    left: 1px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 10px;
    bottom: 1px;    
  }
  .location-badges {
    display: flex;
    align-items: center;
  }
  .location-badges-stacked {
    flex-direction: column;
    align-items: flex-end;
  }
  .location-badges-stacked .location-permission-badge,
  .location-badges-stacked .location-last-sent-badge {
    margin-right: 0 !important;
  }
  .location-badges-stacked .location-last-sent-badge {
    margin-top: 2px;
  }
  .location-last-sent-badge {
    color: #fff;
  }
  .custom-container-change-profile {
    line-height: 2;
  }
  .small-container-change-profile {
    font-size: 15px;
  }
  .containt-logo-custom-minimized {
    object-fit: contain;
    width: 48px;
    height: 48px;
  }
  .containt-logo-custom-full {
    object-fit: contain;
    width: 150px;
    height: 48px;
  }
  .shortcuts-dropdown .dropdown-menu {
    min-width: 320px;
    padding: 0;
  }
  .shortcut-lock-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    padding: 7px 12px;
    background: #f0f0f0;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #6c757d;
    user-select: none;
    transition: background 0.15s;
  }
  .shortcut-lock-bar:hover {
    background: #e4e4e4;
    color: #343a40;
  }
  .shortcut-lock-icon {
    font-size: 12px;
  }
  .shortcuts-dropdown .btn {
    font-weight: 600;
    border-width: 2px;
    border-radius: 0;
  }
  @media (min-width: 992px) {
    .app-header .header-controls-nav {
      height: 100%;
      align-items: center;
    }
    .app-header .header-controls-nav > * {
      align-self: center;
    }
    .shortcuts-dropdown.d-lg-inline-flex {
      height: 100%;
      align-items: stretch;
      align-self: stretch;
    }
    .shortcuts-dropdown.d-lg-inline-flex .btn {
      height: 100%;
      display: inline-flex;
      align-items: center;
    }
  }
  .shortcuts-dropdown-full {
    width: 100%;
    padding: 0;
  }
  .shortcuts-dropdown-full .dropdown-menu {
    padding: 0;
  }
  .shortcuts-dropdown-full .btn {
    width: 100%;
    padding-top: 6px;
    padding-bottom: 6px;
    border-width: 2px;
    border-radius: 0;
  }
  .shortcut-add-divider {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    font-size: 11px;
    color: #007bff;
    cursor: pointer;
    border-bottom: 1px solid #e8e8e8;
    user-select: none;
  }
  .shortcut-add-divider:hover {
    background: #f8f9fa;
    color: #0056b3;
  }
  .shortcut-divider {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 10px;
    background: #f5f5f5;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    margin-top: -1px;
  }
  .shortcut-divider-edit {
    padding: 5px 10px;
  }
  .shortcut-divider-main {
    display: inline-flex;
    align-items: center;
    flex: 1;
    min-width: 0;
  }
  .shortcut-divider-title {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
  }
  .shortcut-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 6px 10px;
    border-bottom: 1px solid #e8e8e8;
  }
  .shortcut-item:last-child {
    border-bottom: none;
  }
  .shortcut-item-compact {
    padding: 4px 10px;
    border-bottom: 1px solid #e0e0e0;
  }
  .shortcut-item-compact:last-child {
    border-bottom: none;
  }
  .shortcut-main {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
    flex: 1;
  }
  .shortcut-item-icon {
    width: 14px;
    text-align: center;
    color: #6c757d;
    flex: 0 0 14px;
  }
  .shortcut-title {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .shortcut-input {
    height: 24px;
    font-size: 12px;
    border-radius: 0;
  }
  .shortcut-actions {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .shortcut-action {
    cursor: pointer;
    opacity: 0.7;
    font-size: 12px;
  }
  .shortcut-action:hover {
    opacity: 1;
  }
  .shortcut-action-save {
    color: #28a745;
  }
  .shortcut-remove {
    cursor: pointer;
    opacity: 0.7;
    font-size: 12px;
    color: #dc3545;
  }
  .shortcut-remove:focus,
  .shortcut-remove:active {
    color: #a71d2a;
    outline: none;
  }
  .shortcut-item:hover .shortcut-remove {
    opacity: 1;
    color: #a71d2a;
  }
  .shortcut-item.active .shortcut-remove {
    color: #a71d2a;
  }
  .shortcuts-dropdown .dropdown-item.active,
  .shortcuts-dropdown .dropdown-item:active,
  .shortcuts-dropdown-full .dropdown-item.active,
  .shortcuts-dropdown-full .dropdown-item:active {
    background-color: transparent;
    color: inherit;
  }
  .shortcuts-dropdown .dropdown-item.active .shortcut-remove,
  .shortcuts-dropdown .dropdown-item:active .shortcut-remove,
  .shortcuts-dropdown-full .dropdown-item.active .shortcut-remove,
  .shortcuts-dropdown-full .dropdown-item:active .shortcut-remove {
    color: #a71d2a;
  }
</style>
<style scoped>
  .alert-clear-cache {
    padding: 0px;
    padding-left: 1.25rem;
    font-size: 10px;
    margin-bottom: 0px;    
  }
  .alert-clear-cache .hide-clear-cache {      
    padding-right: 1.25rem;
    font-size: 15px;
    line-height: 0;      
  }
</style>
